module.exports = __webpack_public_path__ + "04_glasses_black.fafa6170.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer4/04_glasses_black.png
// module id = 6S9M
// module chunks = 0